import * as React from 'react';
import './Footer.css';
import { connect } from 'react-redux';
import DispatchProps, { mapDispatchToProps } from 'src/application/core/DispatchProps';
import ApplicationState from '../application/core/State';
import arrow from './img/arrow_down.svg';

interface Props {
    class: string;
    details: JSX.Element;
    buttons: JSX.Element;
    terms: JSX.Element;
    hasButton?: boolean;
    hiddenDetails?: JSX.Element;
}

interface StateProps {
    productsLoader: boolean;
}

interface State {
    isOpen: boolean;
}

class Footer extends React.PureComponent<StateProps & Props & DispatchProps, State> {
    constructor(props: StateProps & Props & DispatchProps) {
        super(props);
        this.state = {
            isOpen: false
        };
    }
    public render(): JSX.Element {
        return (
            <div className={`footer-container ${this.props.class} ${this.props.productsLoader && 'visible'}`}>
                <div className="footer-container-flex">
                    <div className="footer-container-details">
                        {this.props.hasButton && (
                            <div className="footer-open-button" onClick={this.toggleFooter}>
                                <img className={this.state.isOpen ? 'open' : 'closed'} src={arrow} />
                            </div>
                        )}
                        <div className="footer-details">
                            {this.props.details}

                            {this.state.isOpen && <div>{this.props.hiddenDetails}</div>}
                        </div>
                    </div>
                    <div className="footer-container-terms">{this.props.terms}</div>
                    <div className="footer-container-buttons">{this.props.buttons}</div>
                </div>
            </div>
        );
    }

    private toggleFooter = (): void => {
        this.setState({ isOpen: !this.state.isOpen });
    };
}

const mapStateToProps = (state: ApplicationState): StateProps => ({
    productsLoader: state.products.productsLoader
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Footer);



// WEBPACK FOOTER //
// ./src/view/Footer.tsx